const { getElement } = window.PURELEI.Utils

export class SiteDrawer extends window.PURELEI.CustomElement() {
    constructor () {
        super()

        this.drawers = getElement('site-drawers')
        if (!this.drawers) {
            throw new Error(
                `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
            )
        }
        this.drawers.drawers.push(this)

        this._isOpen = false
    }

    connectedCallback () {
        super.connectedCallback()

        if (this.drawerShouldBeMoved) {
            window.setTimeout(
                () => {
                    const moveToElement = this.moveToElement

                    this.removeAttribute('data-module-drawers-move-me')

                    moveToElement.appendChild(this)
                },
                parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0,
            )
        }
    }

    get key () {
        return this.getAttribute('key')
    }

    get elements () {
        return {
            trigger: getElement(`[data-drawers-trigger=${this.key}]`),
            close: getElement(`[data-module-drawers-close=${this.key}]`),
        }
    }

    get isOpen () {
        return this._isOpen
    }

    set isOpen (val) {
        this._isOpen = val

        this.classList.toggle(this.config.classes.activeDrawerClass, val)
    }

    get drawerShouldBeMoved () {
        return this.hasAttribute('data-module-drawers-move-me')
    }

    get moveToElement () {
        switch (this.getAttribute('data-module-drawers-move-me')) {
            case 'root':
                return this.drawers
            default:
                return getElement(this.getAttribute('data-module-drawers-move-me'))
        }
    }

    get config () {
        return {
            classes: {
                activeDrawerClass: 'drw-Drawer-active',
            },
        }
    }
}

customElements.define('site-drawer', SiteDrawer)
